export default __webpack_public_path__ + "static/media/i160jp.111ae4ee.webp";